import globalStore from "@/store/index";

const login = {
  namespaced: true,
  state: {},
  actions: {
    LOGIN: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios
          .post("/users/authenticate", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_CURRENT_USER: function({ commit }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/users/current-user")
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_USERS: function() {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/users")
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_USERS_PAGINATED: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/users/get-all-users-paginated-for-event-users-list", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    CHECK_USER: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios
          .post("/users/check-is-email-exists", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    REFRESH_TOKEN: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios
          .post("/users/refresh-token", { refreshToken: model })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    LOGOUT_USER: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/users/logout-user", { refreshToken: model })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    SET_USER_DATA_ON_FIRST_LOGIN_STEP_1: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/users/set-user-personal-info-step", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    SET_USER_DATA_ON_FIRST_LOGIN_STEP_2: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/users/set-user-data-on-first-login", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
  },
  mutations: {
    SET_TOKEN: function(state, token) {
      localStorage.setItem("token", token);
      globalStore.state.token = token;
      if (globalStore.state.$axios_auth) {
        globalStore.state.$axios_auth.defaults.headers.common.Authorization = token;
      }
    },
    SET_REFRESH_TOKEN: function(state, token) {
      localStorage.setItem("refresh_token", token);
      globalStore.state.refreshToken = token;
    },
    SET_USER: function(state, user) {
      localStorage.setItem("user", user);
      globalStore.commit("SET_USER", JSON.parse(user));
    },
    LOGOUT_USER: function(state) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      globalStore.state.token = null;
      globalStore.state.refreshToken = null;
      globalStore.state.user = null;
      globalStore.state.$axios = axios.create({
        baseURL: $api,
      });
    },
  },
};
export default login;
